module.exports = __webpack_public_path__ + "static/media/logo.ed4eb826.svg";